import { cn } from '@/lib/utils'

export function ToolbarDivider({ className }) {
  return (
    <div
      className={cn('mx-1 h-6 w-px bg-border', className)}
      role="separator"
      aria-orientation="vertical"
    />
  )
}
